<template>
    <div class="mainBox">
        <div class="main-header">
            <el-row :gutter="10">
                <el-col :span="6">
                    <el-button type="primary" icon='el-icon-plus' size="medium" @click='handleInsert'>新增文章</el-button>
                    <el-button icon='el-icon-refresh' size="medium" @click='getData'>刷新</el-button>
                </el-col>
                <el-col :span="18">
                    <el-form ref="search_form" :model="searchForm" class='search_form'>
                        <el-row :gutter="10">
                            <el-col :span="3" :offset="18">
                                <el-form-item prop="language">
                                    <el-select v-model="searchForm.language" @change='searchFormDatas' placeholder="请选择语言" clearable>
                                        <el-option label="中文" value="cn"></el-option>
                                        <el-option label="英文" value="en"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="primary" class="searchBtn" size="medium" icon='el-icon-search' @click='searchFormDatas'>查询</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>
        </div>
        <el-table :data="singleList" border style="width: 100%">
            <el-table-column label="文章ID" width="100" align="center" prop="id">
            </el-table-column>
            <el-table-column label="语言" width="100" align="center" prop="language">
                <template slot-scope="scope">
                    <span v-if="scope.row.language == 'cn'">中文</span>
                    <span v-if="scope.row.language == 'en'">英文</span>
                </template>
            </el-table-column>
            <el-table-column label="标题" align="center" prop="title">
            </el-table-column>
            <el-table-column label="创建时间" align="center" prop="created_at">
            </el-table-column>
            <el-table-column label="更新时间" align="center" prop="updated_at">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="220" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleEdit(scope.row)" type="primary" size="mini" icon="el-icon-edit-outline">编辑</el-button>
                    <el-button @click.native.prevent="handleDel(scope.row)" type="danger" size="mini" icon="el-icon-delete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <div class="pagination-footer" v-show="pagination.totalNum > 0">
            <el-pagination background layout="prev, pager, next" :current-page="pagination.page" :page-size="pagination.pageSize"
             :total="pagination.totalNum" @current-change="pageChangeAction">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {singleList,singleDel} from '@/utils/getData';

    export default {
        name: "singlePage",
        data() {
            return {
                pagination: {
                    page: 1, //当前页数
                    pageSize: 20, //每页显示的条数
                    totalNum: 100 //总条数
                },
                searchForm: {
                    language:'',
                    title: '',
                    times: [],
                    start_time: '',
                    end_time: ''
                },
                singleList: [],
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                singleList(this.pagination.page,this.searchForm).then(res => {
                    if (res.code == 0) {
                        this.pagination.pageSize = res.data.pageSize;
                        this.pagination.totalNum = res.data.count;
                        this.singleList = res.data.rows;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                })
            },
            searchFormDatas() { //表单搜索
                this.getData();
            },
            pageChangeAction(val) {
                this.pagination.page = val;
                this.getData();
            },
            handleInsert() { //新增文章
                this.$router.push("/singleEdit");
            },
            handleEdit(currentRow) { //编辑账号
                this.$router.push("/singleEdit/"+currentRow.id);
            },
            handleDel(currentRow){
                this.$confirm('确定要删除此文章吗？', '删除文章', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    singleDel(currentRow.id).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                showClose: true,
                                message: '删除成功',
                                type: 'success'
                            });
                            const index = this.singleList.findIndex(item=>{
                                return item.id == currentRow.id;
                            });
                            if(index != -1){
                                this.singleList.splice(index,1)
                            }
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped="scoped">

</style>